import { combineReducers } from 'redux';
import AccessReducer from '../reducers/AccessReducer';
import CandidateReducer from '../reducers/CandidateReducer';
import { DocumentReducer } from '../reducers/DocumentReducer';
import { JobDetailsReducer } from '../reducers/JobDetailsReducer';
import { OpenPositionReducer } from '../reducers/OpenPositionsReducer';
import { CommonReducer } from '../reducers/CommonReducer';
import candidateRecoveryReducer from '../reducers/candidateRecoveryReducer';

export const rootReducer = combineReducers({
    candidateState: CandidateReducer,
    accessState: AccessReducer,
    openPositionsState: OpenPositionReducer,
    documentState: DocumentReducer,
    jobDetailsState: JobDetailsReducer,
    commonState: CommonReducer,
    candidateRecoveryState: candidateRecoveryReducer,
});
